export const setError = (error: ModalError) => ({
  type: "SET_ERROR",
  error,
});
